import { render, staticRenderFns } from "./EstablishmentViewGlobal.vue?vue&type=template&id=bad7fd52"
import script from "./EstablishmentViewGlobal.vue?vue&type=script&lang=js"
export * from "./EstablishmentViewGlobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports